import moment from "moment";

export const localLogDateTime = (value = new Date()) => {
  if (!value) return "";
  const date = moment(value);
  return date.isValid() ? date.format("YYYY-MM-DDTHH:mm") : "";
};

export const logDateTimePayload = (value, captureNow) => {
  if (!captureNow && !value) return "";
  const date = captureNow ? moment() : moment(value);
  return date.isValid() ? date.format() : "";
};
